<template>
  <div>
    <div class="">
      <HomeVue v-if="view == 'home'" @setView="setView" />
    </div>
    <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
  </div>
</template>

<script>
import HomeVue from "../../components/Mozo/demo/HomeDrop.vue";
import FooterVue from "../../components/Mozo/demo/Footer.vue";

export default {
  components: { FooterVue,HomeVue },
  data() {
    return {
      view: "home",
    };
  },
  methods: {
      setView: function (payload) {
        this.$store.commit("mt_set_rol", null);
      },
      mtdViewFooter: function (boo, view) {
        this.booFooter = boo;
        if (boo == true) this.view = view;
      },
  },
};
</script>

<style lang="scss" scoped>
</style>